import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessPage' })(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  helpText: {
    marginBottom: '0px !important',
  },
  successMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'var(--ebl-s1)',
    '@media (max-width: 600px)': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      flexDirection: 'column',
    },
  },
  successMessageButton: {
    '@media (max-width: 600px)': {
      marginTop: 'var(--ebl-s1)',
    },
  },
}));
